// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"37":"lcb","143":"app","271":"playground","465":"bes","535":"login","627":"applicant"}[chunkId] + ".css";
};